import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
// import { FieldError, Notification } from "../../../assets";
// import { useAuth } from "../../../Navigation/Auth/ProvideAuth";
// import {
//   editOrganization,
//   getOrganizationList,
// } from "../../../redux/actions/organiaztionAction";
// import { FieldError } from "components/util-components/ErrorMessage";

export default function EditOrganizationModal(props) {
  const { editHandleClose, editShow, organizationId } = props;
  return (
    <Modal
      className="p-0"
      aria-labelledby="contained-modal-title-vcenter"
      id="user-welcome-card"
      centered
      show={editShow}
      onHide={() => editHandleClose()}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header
        className="mx-4 pb-3 px-0 d-flex align-items-end"
        closeButton
      >
        <h5 className="generic-heading-level-3">Edit Project</h5>
      </Modal.Header>
      <ModalBody {...props} />
    </Modal>
  );
}
function ModalBody(props) {
  console.log("props", props);
  // const { register, handleSubmit, errors } = useForm();
  // let auth = useAuth();
  // let token = auth.user.token;
  let dispatch = useDispatch();
  function moveToNext() {
    props.editHandleClose();
  }
  function onSubmit(data) {
    // let finalData = {
    //   organizationId: props.organizationId?.organizationId,
    //   organizationName: data.organizationName,
    //   connectionString: "",
    //   createdById: auth.user.userId,
    // };
    // dispatch(editOrganization(finalData, token, moveToNext, Notification));
  }
  return (
    <form>
      <Modal.Body className="py-0 px-2">
        <div className="px-3 b7">
          <Row className="mb-2 mt-3">
            <Col lg="12">
              <Form.Group className="mb-2">
                <label className="salary-labels">{"Organization Name"}</label>
                <Form.Control
                  className="mb-2"
                  type="Text"
                  name="organizationName"
                  defaultValue={props.organizationId.organizationName}
                  placeholder="Organization Name"
                  // ref={register({ required: true, pattern: /[^\s]+/ })}
                />
                {/* {errors.organizationName && (
                  <FieldError message={"This field is required."} />
                )} */}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <Button
                type="submit"
                className="mt-4 py-2 mt-3 mb-4 w-100 button-sizes Home-buttons"
              >
                Save
              </Button>
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </form>
  );
}
